import ApiAccess from "@/services/ApiAccess.js";

export const state = {
  family: []
};

export const mutations = {
  SET_FAMILY(state, family) {
    state.family = family;
  }
};

export const actions = {
  fetchFamily({ commit, dispatch }) {
    return ApiAccess.getFamily()
      .then(response => {
        var family = response.data.data.reverse();
        commit("SET_FAMILY", family);
        return family;
      })
      .catch(error => {
        dispatch("setNotification", "Error Fetching Family: " + error.message, {
          root: true
        });
      });
  }
};
